import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatSlideToggle } from '@angular/material/slide-toggle';

@Component({
  selector: 'app-slide-toggle',
  standalone: true,
  imports: [MatSlideToggle],
  templateUrl: './slide-toggle.component.html',
  styleUrl: './slide-toggle.component.css',
})
export class SlideToggleComponent {
  @Input() checked = false;
  @Input() disabled = false;
  /** Shows a spinner in the thumb (replacing the check/dash icon) and blocks interaction, without the dimmed disabled look. */
  @Input() loading = false;
  @Input({ required: true }) label = '';
  @Output() checkedChange = new EventEmitter<boolean>();
}
